import http from '../common/http';
import env from '../envConfig';
import { getHeader, getHeaderIdPositiva } from '../auth/authManager';
import { responseHandler } from '../common/responseHandler';
import queryString from 'query-string';
import { PessoaModel } from '../model/Pessoa';

export const obterTermoDeUsoGovBr = async (cpf: string) => {
  const url = env.urlApi + `/transacional-api/v1/profile/termo-de-uso-assinado/${cpf}/`;

  const headers = getHeader();

  const response = await http.post(url, null, { headers });
  return responseHandler(response);
};

export const obterTermoDeUsoIdPositiva = async (pessoa: PessoaModel) => {
  const url = env.urlApi + `/transacional-api/v1/profile/termo-de-uso-assinado/${pessoa.nomePessoa}/${pessoa.nomeDaMae}/${pessoa.dataNascimento}`;

  const headers = getHeaderIdPositiva();

  const response = await http.post(url, null, { headers });
  return responseHandler(response);
};

export const postAssinarTermoDeUsoGovBr = async (cpf: string) => {
  const url = env.urlApi + `/transacional-api/v1/profile/assinar-termo-de-uso/${cpf}`;

  const headers = getHeader();

  const response = await http.post(url, null, { headers });
  return responseHandler(response);
};

export const postAssinarTermoDeUsoIdPositiva = async (pessoa: PessoaModel) => {
  const url = env.urlApi + `/transacional-api/v1/profile/assinar-termo-de-uso`;

  const headers = getHeaderIdPositiva({
    Accept: 'text/pdf,application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
  });

  let formatedData = queryString.stringify(pessoa);

  const response = await http.post(url, formatedData, { headers });
  return responseHandler(response);
};

